import { SymptomActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const SymptomReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case SymptomActionType.Symptom_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default SymptomReducer
